import React, {PureComponent} from 'react';
import {connect} from 'react-redux';
import PropTypes from 'prop-types';
import cx from 'classnames';
import AttachFileIcon from '@material-ui/icons/AttachFile';
import {popupShow} from 'actions/popup';
import uuid from 'uuid/v1';
import Popup from 'components/common/Popup';
import axios from 'axios';
import ButtonIcon from 'components/common/ButtonIcon';
import {fetchFile} from 'api/debtCollectionMonitor';

@connect()
class ButtonAttachFile extends PureComponent {
  state = {
    queue: []
  };

  uploadFile = async (fls) => {
    const { isDrag } = this.state;
    if (isDrag) this.setState({isDrag: false});

    let {onFetching, onFetchingComplete, onFetchingError, onChange, dispatch} = this.props;

    if (!fls || fls.length <= 0) return;
    let file = fls[0];

    const fileName = file.name;
    const fileSize = file.size;
    if (fileSize >= 524288000) {
      dispatch(popupShow(`Не возможно прикрепить файл. Максимальный размер файла 524 мегабайта. \n${fileName}`, {display: Popup.display.error}));
      return;
    }

    const queueKey = uuid();
    this.setState({queue: (this.state.queue || []).concat([{key: queueKey, name: file.name}])});
    const fetchingFile = {key: queueKey, name: fileName};
    if (onFetching) onFetching(fetchingFile);

    try {
      const fileId = await fetchFile({file}, {axios});
      const fileObject = {id: fileId, name: fileName};

      if (onFetchingComplete) onFetchingComplete(fetchingFile);
      if (onChange) onChange(fileObject, queueKey);
    } catch (e) {

      dispatch(popupShow(`Во время загрузки файла произошла ошибка, вы можете попробовать прикрепить его еще раз.\n${fileName}`, {display: Popup.display.error}));
      fetchingFile.error = Popup.display.error;
      if (onFetchingError) onFetchingError(fetchingFile);
    }

    this.setState({queue: (this.state.queue || []).filter(a => a.key !== queueKey)});
  };


  //измениен прикрепленного файла
  handlerOnFileChange = async (e) => {
    let files = {...e.target.files};

    if (this.inputFileRef) {
      this.inputFileRef.value = '';
    }

    //если файл не выбран
    await this.uploadFile(files);
  };

  inputFileRef;

  render() {
    const {className: classBox, classIcon} = this.props;

    return (
      <div className={cx(classBox)}>
        <input ref={(r) => this.inputFileRef = r} type='file' onChange={this.handlerOnFileChange} style={{display: 'none'}}  />
        <ButtonIcon tooltip={'Прикрепить файл'} onClick={() => {if (this.inputFileRef) this.inputFileRef.click()}}><AttachFileIcon className={classIcon} /></ButtonIcon>
      </div>
    );
  }
}

ButtonAttachFile.propTypes = {
  className: PropTypes.string,
  classIcon: PropTypes.string,
  onChange: PropTypes.func,

  onFetching: PropTypes.func,
  onFetchingError: PropTypes.func,
  onFetchingComplete: PropTypes.func,
};

export default ButtonAttachFile;


// WEBPACK FOOTER //
// ./src/components/common/AttachFile/ButtonAttachFile.jsx